import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-notebook-dialog',
  template: `
  <h1 mat-dialog-title>New Notebook</h1>

  <div mat-dialog-content class="content">
    <mat-form-field class="pl-3 pr-3">
      <mat-label>Notebook name</mat-label>
      <input matInput [(ngModel)]="data" cdkFocusInitial/>
    </mat-form-field>
   </div>

  <mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="data" >Save</button>
  </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.scss']
})
export class CreateNotebookDialogComponent implements OnInit {

  data: string = '';

  constructor(
    public dialogRef: MatDialogRef<CreateNotebookDialogComponent>
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
